'use strict'

import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export const store = new Vuex.Store({
  state: {
    layout: 'login-layout',
    id_group: false
  },
  mutations: {
    SET_LAYOUT(state, payload) {
      state.layout = payload
    },
    SET_ID_GROUP(state, id_group) {
      state.id_group = id_group
    }
  },
  getters: {
    layout(state) {
      return state.layout
    },
    id_group(state) {
      return state.id_group
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js